import React from 'react';

import { Handle, Position } from '@xyflow/react';

import { colors } from '../../theme/colors';

/**
 * Action Frame Node component
 * Renders a frame around related nodes
 *
 * @param {Object} props - Component props
 * @returns {JSX.Element} The rendered component
 */
const ActionFrameNode = ({ data, selected, id }) => {
  // Extract section title from comment if available
  let sectionTitle = data?.label || 'Action Frame';
  if (data?.comment && data.comment.includes('###')) {
    // Extract the part between ### marks
    const match = data.comment.match(/#{3,}(.*?)#{3,}/);
    if (match && match[1]) {
      sectionTitle = match[1].trim();
    }
  }

  return (
    <div
      className="action-frame"
      style={{
        backgroundColor: 'rgba(255, 243, 205, 0.25)',
        borderStyle: 'dashed',
        borderWidth: '2px',
        borderColor: selected ? colors.primary : '#ffd249',
        borderRadius: '4px',
        position: 'relative',
        width: '100%',
        height: '100%',
        zIndex: -5,
        padding: '4px',
        overflow: 'visible',
      }}
      data-id={id}
      data-nodetype="actionFrame"
    >
      <div
        style={{
          position: 'absolute',
          top: '5px',
          left: '10px',
          padding: '2px 8px',
          borderRadius: '4px',
          backgroundColor: 'rgba(255, 243, 205, 0.9)',
          fontSize: '14px',
          fontWeight: 'bold',
          border: '1px solid #ffd249',
          zIndex: 10,
        }}
      >
        {sectionTitle}
        {data.childrenCount && (
          <span style={{ marginLeft: '8px', fontSize: '11px', opacity: 0.8 }}>
            ({data.childrenCount} nodes)
          </span>
        )}
      </div>
      {/* Invisible handles to allow connections to the frame */}
      <Handle type="target" position={Position.Left} style={{ opacity: 0 }} isConnectable={false} />
      <Handle
        type="source"
        position={Position.Right}
        style={{ opacity: 0 }}
        isConnectable={false}
      />
    </div>
  );
};

export default ActionFrameNode;
